// Mobile Gallery Dots Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile when dots are enabled
  if (window.innerWidth <= 767 && document.querySelector('.mobile-gallery-dots')) {
    const dots = document.querySelectorAll('.gallery-dot');
    const slider = document.querySelector('.primgSlider');
    
    if (dots.length && slider) {
      // Add click handlers to dots
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Remove active class from all dots
          dots.forEach(d => d.classList.remove('active'));
          // Add active class to clicked dot
          this.classList.add('active');
          
          // Trigger slick slider to go to this slide
          if (window.jQuery && jQuery.fn.slick) {
            jQuery(slider).slick('slickGoTo', index);
          }
        }, { passive: false });
      });
      
      // Update dots when slider changes
      if (window.jQuery && jQuery.fn.slick) {
        jQuery(slider).on('afterChange', function(event, slick, currentSlide) {
          dots.forEach(function(dot, index) {
            if (index === currentSlide) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        });
      }
    }
  }
});
